module.exports = {
  externalPayProviderSelector: {
    label: 'Selecione o metodo de transferência eletrônica:',
  },
  paymentMethodInfo: {
    achpse: 'Você será redirecionado para o site do banco selecionado para autorizar o débito dos fundos. Disponível para poupança, conta corrente ou depósito eletrônico.',
    bancolombia: 'Disponível para conta corrente e poupança. Ao escolher este método de pagamento, você será redirecionado para o site do Bancolombia.',
  },
  fawryLabel: 'Pagar por Fawry',
};
